import { ModuleConfigDescription } from 'data/terra/ModuleConfig';
import { normalizeConfig } from 'data/terra/ModuleConfig/util';

export const normalize = (config: ModuleConfigDescription<any, any>): any => {
  return {
    ...config,
    data: normalizeConfig(config.data),
    displayInfo: {
      ...config.displayInfo,
      order: Number(config.displayInfo.order),
    },
  };
};
